// These are permission names used by this portal, not permissions inferred from roles.
// Keep backend spelling, including "dev_resourses", because me.permissions is authoritative.
export const permissions = {
  user: ['read', 'update', 'delete'],
  role: ['read'],
  invite: ['create'],
  dev_resourses: ['read'],
  game_session_admin: ['access'],
  device_manage_admin: ['access'],
} as const;
